import { ColorPalette } from '@/types/brandingThemes';
import { SelectOption } from '@/types/inputs';

export const defaultColorPalette: ColorPalette = {
  primary: '#ED6731',
  secondary: '#62656a',

  // These colors are applied to all branding themes and are never overriden
  tertiary: '#C7C7C7',
  error: '#dd3929',
  success: '#0fa30c',
  white: '#ffffff',
  black: '#000000',
  border: '#C7C7C7',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '48px',
  xxl: '56px',
};

export const contentWidths = {
  default: '1500px',
  small: '750px',
};

export const BRANDING_THEME_SUBHEADER_DEMO_BOXES = [
  { title: 'Total Balance', value: '$50,636.48' },
  { title: 'Pending Deposits', value: '$1,745.12' },
  { title: 'YTD Interest Earned', value: '$3,015.89' },
];
export const BRANDING_THEME_DEMO_BANK_ACCOUNT = [
  {
    id: '53587028-ec83-4b75-bebd-bcfae83cfe0e',
    accountId: 'acct_11jxsx0qt3q2m5',
    accountNumber: '137053791210',
    routingNumber: '000000000',
    accountType: 'savings',
    status: 'open',
    createdAt: '2024-02-26T20:27:10.565Z',
    rateSavingInterest: '3.0',
    currentBalance: {
      currency: 'usd',
      value: '45146.07',
    },
    availableBalance: {
      currency: 'usd',
      value: '45146.07',
    },
    pendingTransactionBalance: {
      currency: 'usd',
      value: '3321.0200',
    },
    owners: [
      {
        id: '28d7be0d-b72e-403c-adf4-4b60202f5dbe',
        primary: true,
        profile: {
          id: '28d7be0d-b72e-403c-adf4-4b60202f5dbe',
          firstName: 'John',
          lastName: 'Doe',
          middleName: '',
        },
      },
    ],
    ownershipType: 'individual',
    legalBusinessName: null,
    dateClosed: null,
    dateLocked: null,
    feeSettings: {
      accountFee: {
        incomingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        outgoingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        monthlySavingAccount: {
          currency: 'usd',
          value: '55.0',
        },
      },
      companyFee: {
        incomingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        outgoingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        monthlySavingAccount: {
          currency: 'usd',
          value: '55.0',
        },
      },
      programSettingFee: {
        incomingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        outgoingDomestic: {
          currency: 'usd',
          value: '55.0',
        },
        monthlySavingAccount: {
          currency: 'usd',
          value: '55.0',
        },
      },
    },
    achControlSettings: {
      transferLimit: {
        currency: 'usd',
        value: '150000.00',
      },
      monthlyLimit: {
        currency: 'usd',
        value: '150000.00',
      },
      totalAccumulatedAmount: {
        currency: 'usd',
        value: '10.0000',
      },
      isWireOutOverrideEnabled: false,
      wireOutOverrideLimit: {
        currency: 'usd',
        value: '150000.00',
      },
    },
    last4Digit: '1210',
    value: '53587028-ec83-4b75-bebd-bcfae83cfe0e',
    label: 'Savings - Individual\nJ.Doe ...1210',
    accountInfoLabel: 'Savings - Individual',
    userInfoLabel: 'J.Doe ...1210',
    isInternalAccount: true,
    additionalInfo: '$45,146.07',
  },
];

export const BRANDING_THEME_INTRO_VIDEO_OPTIONS: SelectOption[] = [
  {
    label: 'America',
    value: 'America',
  },
  {
    label: 'Arizona',
    value: 'Arizona',
  },
  {
    label: 'Atlanta',
    value: 'Atlanta',
  },
  {
    label: 'Chicago',
    value: 'Chicago',
  },
  {
    label: 'Florida',
    value: 'Florida',
  },
  {
    label: 'Laguna',
    value: 'Laguna',
  },
  {
    label: 'Los Angeles',
    value: 'Los Angeles',
  },
  {
    label: 'Massachusetts',
    value: 'Massachusetts',
  },
  {
    label: 'Michigan',
    value: 'Michigan',
  },
  {
    label: 'Minnesota',
    value: 'Minnesota',
  },
  {
    label: 'National',
    value: 'National',
  },
  {
    label: 'New Jersey',
    value: 'New Jersey',
  },
  {
    label: 'New York',
    value: 'New York',
  },
  {
    label: 'North East',
    value: 'North East',
  },
  {
    label: 'Ohio',
    value: 'Ohio',
  },
  {
    label: 'Oklahoma',
    value: 'Oklahoma',
  },
  {
    label: 'San Diego',
    value: 'San Diego',
  },
  {
    label: 'San Francisco',
    value: 'San Francisco',
  },
  {
    label: 'South East',
    value: 'South East',
  },
  {
    label: 'Texas',
    value: 'Texas',
  },
];

export const BRANDING_THEME_FONT_OPTIONS: SelectOption[] = [
  {
    label: 'Arial',
    value: 'Arial',
  },
  {
    label: 'Lato',
    value: 'Lato',
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
  },
  {
    label: 'Myriad',
    value: 'Myriad',
  },
  {
    label: 'Open Sans',
    value: 'Open Sans',
  },
  {
    label: 'PT Sans',
    value: 'PT Sans',
  },
  {
    label: 'PT Serif',
    value: 'PT Serif',
  },
  {
    label: 'Roboto',
    value: 'Roboto',
  },
];

export const BRANDING_THEME_CUSTOM_BACKGROUND_OPTIONS: SelectOption[] = [
  {
    label: 'Silver Metal',
    value: 'Silver Metal',
  },
  {
    label: 'Dark Metal',
    value: 'Dark Metal',
  },
];
